// extracted by mini-css-extract-plugin
export default {"title":"styles_title__JTKV2","buttons":"styles_buttons__gGGC2","description":"styles_description__J3flX"};